'use strict';
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __await = (this && this.__await) || function (v) { return this instanceof __await ? (this.v = v, this) : new __await(v); }
var __asyncGenerator = (this && this.__asyncGenerator) || function (thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var e_1, _a;
var _Spell_instances, _Spell_emptySpell;
/**
 * The {@link Spell} class.
 * @module
 */
var pluralize = require('pluralize');
var SqlString = require('sqlstring');
var _b = require('./expr'), parseExprList = _b.parseExprList, parseExpr = _b.parseExpr, walkExpr = _b.walkExpr;
var _c = require('./utils'), isPlainObject = _c.isPlainObject, deepClone = _c.deepClone;
var _d = require('./hint'), IndexHint = _d.IndexHint, INDEX_HINT_TYPE = _d.INDEX_HINT_TYPE, Hint = _d.Hint;
var parseObject = require('./query_object').parseObject;
var Raw = require('./raw').default;
var AGGREGATOR_MAP = require('./constants').AGGREGATOR_MAP;
/**
 * check condition to avoid use virtual fields as where conditions
 * @param {Bone} Model
 * @param {Array<Object>} conds
 */
function checkCond(Model, conds) {
    var e_2, _a;
    if (Array.isArray(conds)) {
        try {
            for (var conds_1 = __values(conds), conds_1_1 = conds_1.next(); !conds_1_1.done; conds_1_1 = conds_1.next()) {
                var cond = conds_1_1.value;
                if (cond.type === 'id' && cond.value != null) {
                    if (Model.attributes[cond.value] && Model.attributes[cond.value].virtual) {
                        throw new Error("unable to use virtual attribute ".concat(cond.value, " as condition in model ").concat(Model.name));
                    }
                }
                else if (cond.type === 'op' && cond.args && cond.args.length) {
                    checkCond(Model, cond.args);
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (conds_1_1 && !conds_1_1.done && (_a = conds_1.return)) _a.call(conds_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
    }
}
/**
 * Parse condition expressions
 * @example
 * parseConditions(Model, { foo: { $op: value } });
 * parseConditions(Model, 'foo = ?', value);
 * @param {Bone} Model
 * @param {(string|Object)} conditions
 * @param {...*} values
 * @returns {Array}
 */
function parseConditions(Model, conditions) {
    var values = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        values[_i - 2] = arguments[_i];
    }
    if (conditions instanceof Raw)
        return [conditions];
    var conds;
    if (isPlainObject(conditions)) {
        conds = parseObject(conditions);
    }
    else if (typeof conditions == 'string') {
        conds = [parseExpr.apply(void 0, __spreadArray([conditions], __read(values), false))];
    }
    else {
        throw new Error("unexpected conditions ".concat(conditions));
    }
    checkCond(Model, conds);
    return conds;
}
function parseSelect(spell) {
    var e_3, _a, e_4, _b;
    var names = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        names[_i - 1] = arguments[_i];
    }
    var joins = spell.joins, Model = spell.Model;
    if (typeof names[0] === 'function') {
        names = Object.keys(Model.columnAttributes).filter(names[0]);
    }
    else {
        names = names.reduce(function (result, name) { return result.concat(name); }, []);
    }
    var columns = [];
    try {
        for (var names_1 = __values(names), names_1_1 = names_1.next(); !names_1_1.done; names_1_1 = names_1.next()) {
            var name_1 = names_1_1.value;
            if (name_1 instanceof Raw)
                columns.push(name_1);
            else
                columns.push.apply(columns, __spreadArray([], __read(parseExprList(name_1)), false));
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (names_1_1 && !names_1_1.done && (_a = names_1.return)) _a.call(names_1);
        }
        finally { if (e_3) throw e_3.error; }
    }
    try {
        for (var columns_1 = __values(columns), columns_1_1 = columns_1.next(); !columns_1_1.done; columns_1_1 = columns_1.next()) {
            var ast = columns_1_1.value;
            walkExpr(ast, function (token) {
                var type = token.type, qualifiers = token.qualifiers, value = token.value;
                if (type != 'id')
                    return;
                var qualifier = qualifiers && qualifiers[0];
                var model = qualifier && joins && (qualifier in joins) ? joins[qualifier].Model : Model;
                if (!model.columnAttributes[value]) {
                    if (model.attributes[value]) {
                        throw new Error("unable to use virtual attribute ".concat(value, " as field in model ").concat(model.name));
                    }
                    throw new Error("unable to find attribute ".concat(value, " in model ").concat(model.name));
                }
            });
        }
    }
    catch (e_4_1) { e_4 = { error: e_4_1 }; }
    finally {
        try {
            if (columns_1_1 && !columns_1_1.done && (_b = columns_1.return)) _b.call(columns_1);
        }
        finally { if (e_4) throw e_4.error; }
    }
    return columns;
}
/**
 * Translate key-value pairs of columnAttributes into key-value pairs of columns. Get ready for the SET part when generating SQL.
 * @param {Spell} spell
 * @param {Object} obj - key-value pairs of columnAttributes
 * @param {boolean} strict - check attribute exist or not
 * @returns {Object}
 */
function formatValueSet(spell, obj, strict) {
    if (strict === void 0) { strict = true; }
    var Model = spell.Model;
    var sets = {};
    for (var name_2 in obj) {
        var attribute = Model.columnAttributes[name_2];
        var value = obj[name_2];
        if (!attribute) {
            continue;
        }
        // raw sql don't need to uncast
        if (value instanceof Raw) {
            sets[name_2] = value;
        }
        else {
            sets[name_2] = attribute.uncast(value);
        }
    }
    return sets;
}
/**
 * Translate key-value pairs of columnAttributes into key-value pairs of columns. Get ready for the SET part when generating SQL.
 * @param {Spell}  spell
 * @param {Object|Array} obj   - key-value pairs of columnAttributes
 */
function parseSet(spell, obj) {
    var e_5, _a;
    var sets;
    if (Array.isArray(obj)) {
        sets = [];
        try {
            for (var obj_1 = __values(obj), obj_1_1 = obj_1.next(); !obj_1_1.done; obj_1_1 = obj_1.next()) {
                var o = obj_1_1.value;
                // bulk write should not check attribute existence strictly
                sets.push(formatValueSet(spell, o, false));
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (obj_1_1 && !obj_1_1.done && (_a = obj_1.return)) _a.call(obj_1);
            }
            finally { if (e_5) throw e_5.error; }
        }
    }
    else {
        sets = formatValueSet(spell, obj);
    }
    return sets;
}
/**
 * Construct on conditions as ast from associations.
 * @example
 * joinOnConditions(spell, Post, 'posts', 'comments', {
 *   association: { Model: Comment, foreignKey: 'postId' }
 * });
 *
 * @param {Spell}  spell
 * @param {Model}  BaseModel
 * @param {string} baseName
 * @param {string} refName
 * @param {Object} opts
 * @param {Object} opts.association - the association between BaseModel and RefModel
 * @param {Object} opts.where    - used to override association.where when processing `{ through }` associations
 */
function joinOnConditions(spell, BaseModel, baseName, refName, _a) {
    var _b = _a === void 0 ? {} : _a, where = _b.where, association = _b.association;
    var RefModel = association.Model, foreignKey = association.foreignKey, belongsTo = association.belongsTo;
    var _c = __read(belongsTo
        ? [foreignKey, RefModel.primaryKey]
        : [BaseModel.primaryKey, foreignKey], 2), baseKey = _c[0], refKey = _c[1];
    var onConditions = {
        type: 'op', name: '=',
        args: [
            { type: 'id', value: baseKey, qualifiers: [baseName] },
            { type: 'id', value: refKey, qualifiers: [refName] }
        ]
    };
    if (!where)
        where = association.where;
    if (where) {
        var whereConditions = parseConditions(BaseModel, where).reduce(function (result, condition) {
            if (!result)
                return condition;
            return { type: 'op', name: 'and', args: [result, condition] };
        });
        walkExpr(whereConditions, function (node) {
            if (node.type == 'id')
                node.qualifiers = [refName];
        });
        return { type: 'op', name: 'and', args: [onConditions, whereConditions] };
    }
    else {
        return onConditions;
    }
}
/**
 * Find association by certain criteria.
 * @example
 * findAssociation({ Model: Post });
 * @param {Object} associations - Model associations
 * @param {Object} opts      - Search criteria, e.g. { Model }
 */
function findAssociation(associations, opts) {
    for (var qualifier in associations) {
        var association = associations[qualifier];
        var found = true;
        for (var name_3 in opts) {
            if (opts[name_3] != association[name_3]) {
                found = false;
                break;
            }
        }
        if (found)
            return association;
    }
    return null;
}
/**
 * Parse associations into spell.joins
 * @param {Spell}  spell     - An instance of spell
 * @param {Model}  BaseModel - A subclass of Bone
 * @param {string} baseName  - Might be Model.tableAlias, Model.table, or other names given by users
 * @param {string} refName   - The name of the join target
 * @param {Object} opts      - Extra options such as { select, throughAssociation }
 */
function joinAssociation(spell, BaseModel, baseName, refName, opts) {
    var e_6, _a, _b;
    if (opts === void 0) { opts = {}; }
    var joins = spell.joins;
    var association = BaseModel.associations[refName] || BaseModel.associations[pluralize(refName, 1)];
    if (refName in joins)
        throw new Error("duplicated ".concat(refName, " in join tables"));
    if (!association && opts.targetAssociation) {
        association = findAssociation(BaseModel.associations, { Model: opts.targetAssociation.Model });
    }
    if (!association) {
        throw new Error("unable to find association ".concat(refName, " on ").concat(BaseModel.name));
    }
    var through = association.through, RefModel = association.Model, includes = association.includes;
    if (through) {
        var throughAssociation_1 = BaseModel.associations[through];
        // multiple associations might be mounted through the same intermediate association.
        // such as tagMaps => colorTags, tagMaps => styleTags
        // in this case, the intermediate association shall be mounted only once.
        if (!joins[through])
            joinAssociation(spell, BaseModel, baseName, through);
        joinAssociation(spell, throughAssociation_1.Model, through, refName, __assign(__assign({}, opts), { throughAssociation: throughAssociation_1, targetAssociation: association }));
        return;
    }
    var throughAssociation = opts.throughAssociation, targetAssociation = opts.targetAssociation;
    var where = targetAssociation ? targetAssociation.where : null;
    var select = opts.select || association.select;
    if (select) {
        var columns = parseSelect({ Model: RefModel }, select);
        try {
            for (var columns_2 = __values(columns), columns_2_1 = columns_2.next(); !columns_2_1.done; columns_2_1 = columns_2.next()) {
                var token = columns_2_1.value;
                walkExpr(token, function (node) {
                    if (node.type === 'id' && !node.qualifiers && RefModel.columnAttributes[node.value]) {
                        node.qualifiers = [refName];
                    }
                });
            }
        }
        catch (e_6_1) { e_6 = { error: e_6_1 }; }
        finally {
            try {
                if (columns_2_1 && !columns_2_1.done && (_a = columns_2.return)) _a.call(columns_2);
            }
            finally { if (e_6) throw e_6.error; }
        }
        (_b = spell.columns).push.apply(_b, __spreadArray([], __read(columns), false));
    }
    spell.joins[refName] = {
        Model: RefModel,
        on: joinOnConditions(spell, BaseModel, baseName, refName, { where: where, association: association }),
        hasMany: association.hasMany || (throughAssociation ? throughAssociation.hasMany : false),
    };
    if (includes)
        joinAssociation(spell, RefModel, refName, includes);
}
/**
 * If Model supports soft delete, and deletedAt isn't specified in whereConditions yet, and the table isn't a subquery, append a default where({ deletedAt: null }).
 */
function scopeDeletedAt(spell) {
    var e_7, _a, _b;
    var table = spell.table, sets = spell.sets, whereConditions = spell.whereConditions, Model = spell.Model;
    var deletedAt = Model.timestamps.deletedAt;
    // from subquery
    if (table.type !== 'id')
        return;
    // UPDATE users SET deleted_at = NULL WHERE id = 42;
    if (sets && sets[deletedAt] === null)
        return;
    var _loop_3 = function (condition) {
        var found = false;
        walkExpr(condition, function (_a) {
            var type = _a.type, value = _a.value;
            if (type === 'id' && value == deletedAt) {
                found = true;
            }
        });
        if (found)
            return { value: void 0 };
    };
    try {
        // deletedAt already specified
        for (var whereConditions_1 = __values(whereConditions), whereConditions_1_1 = whereConditions_1.next(); !whereConditions_1_1.done; whereConditions_1_1 = whereConditions_1.next()) {
            var condition = whereConditions_1_1.value;
            var state_1 = _loop_3(condition);
            if (typeof state_1 === "object")
                return state_1.value;
        }
    }
    catch (e_7_1) { e_7 = { error: e_7_1 }; }
    finally {
        try {
            if (whereConditions_1_1 && !whereConditions_1_1.done && (_a = whereConditions_1.return)) _a.call(whereConditions_1);
        }
        finally { if (e_7) throw e_7.error; }
    }
    spell.$where((_b = {}, _b[deletedAt] = null, _b));
}
scopeDeletedAt.__paranoid = true;
/**
 * Spell is the query builder of Leoric which has several important characters that made a powerful querying interface possible.
 *
 * - Deferred
 * - Method chaining
 * - Parsing SQL expressions
 *
 * Some of the methods of Spell follow such pattern:
 *
 * - Methods that begin with `$`, such as {@link Spell#$group}, are methods that support chaining. For example, we can do `new Spell().$select('foo').$group('bar')` to construct an SQL query.
 * - These methods have twin methods without the `$`, which have the same functionalities but differ in only one thing, every call of these methods makes changes on a duplicate of current spell and returns the duplicated one. For example, `new Spell().select('foo').group('bar')` works and each call, `new Spell()`, `.select('foo')`, and `.group('bar')`, returns a new spell.
 *
 * Spell adapts this pattern to make following usage possible:
 *
 *     const query = Post.find('createdAt > ?', new Date(2012, 4, 15));
 *     const [ { count } ] = query.count();
 *     const posts = query.offset(page * pageSize).limit(pageSize);
 *     this.body = { count, posts }
 *
 * `query.count()` and `query.offset()` won't interfere with each other because `new Spell` gets returned every time these methods were called. For brevity, only the methods start with `$` are documented.
 *
 * For performance reason, {@link Bone} use the prefixed with `$` ones mostly.
 * @alias Spell
 */
var Spell = /** @class */ (function () {
    /**
     * Create a spell.
     * @param {Model}          Model    - A sub class of {@link Bone}.
     * @param {Object}         opts     - Extra columnAttributes to be set.
     */
    function Spell(Model, opts) {
        if (opts === void 0) { opts = {}; }
        _Spell_instances.add(this);
        if (Model.synchronized == null) {
            throw new Error("model ".concat(Model.name, " is not connected yet"));
        }
        var scopes = [];
        if (Model._scope) {
            scopes.push(Model._scope);
        }
        var deletedAt = Model.timestamps.deletedAt;
        // FIXME: need to implement paranoid mode
        if (Model.columnAttributes[deletedAt] && opts.paranoid !== false) {
            scopes.push(scopeDeletedAt);
        }
        if (opts.scopes && opts.scopes.length) {
            scopes.push.apply(scopes, __spreadArray([], __read(opts.scopes), false));
        }
        this.scopes = scopes;
        /**
         * A sub-class of Bone.
         */
        this.Model = Model;
        this.laters = [];
        // transaction options is passed around in opts.transaction in sequelize adapter
        Object.assign(this, {
            command: 'select',
            columns: [],
            table: parseExpr(Model.table),
            whereConditions: [],
            groups: [],
            orders: [],
            havingConditions: [],
            joins: {},
            skip: 0,
            subqueryIndex: 0
        }, opts.transaction, opts);
        var hints = [];
        if (opts.hints && opts.hints.length) {
            hints.push.apply(hints, __spreadArray([], __read(opts.hints.map(function (hint) { return Hint.build(hint); })), false));
        }
        if (opts.hint) {
            hints.push(Hint.build(opts.hint));
        }
        this.hints = hints.reduce(function (result, hint) {
            if (!result.some(function (entry) { return entry.isEqual(hint); })) {
                result.push(hint);
            }
            return result;
        }, []);
    }
    Spell.expr = function (text) {
        return __assign(__assign({}, parseExpr(text)), { __expr: true });
    };
    Object.defineProperty(Spell.prototype, "unscoped", {
        get: function () {
            var spell = this.dup;
            spell.scopes = [];
            return spell;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Spell.prototype, "unparanoid", {
        // remove `deleted is NULL`
        get: function () {
            var spell = this.dup;
            spell.scopes = spell.scopes.filter(function (scope) { return !scope.__paranoid; });
            return spell;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Spell.prototype, "all", {
        get: function () {
            return this;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Spell.prototype, "first", {
        get: function () {
            return this.order(this.Model.primaryKey).$get(0);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Spell.prototype, "last", {
        get: function () {
            return this.order(this.Model.primaryKey, 'desc').$get(0);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Spell.prototype, "dup", {
        /**
         * Get a duplicate of current spell.
         * @returns {Spell}
         */
        get: function () {
            return new Spell(this.Model, {
                command: this.command,
                columns: __spreadArray([], __read(this.columns), false),
                sets: this.sets,
                table: this.table,
                whereConditions: __spreadArray([], __read(this.whereConditions), false),
                groups: __spreadArray([], __read(this.groups), false),
                orders: __spreadArray([], __read(this.orders), false),
                havingConditions: __spreadArray([], __read(this.havingConditions), false),
                joins: this.joins,
                skip: this.skip,
                rowCount: this.rowCount,
                scopes: __spreadArray([], __read(this.scopes), false),
                laters: __spreadArray([], __read(this.laters), false),
                hints: __spreadArray([], __read(this.hints), false),
                // used by transaction
                connection: this.connection,
            });
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Get nth record.
     * @param {number} index
     * @returns {Bone}
     */
    Spell.prototype.$get = function (index) {
        var _this = this;
        this.$limit(1);
        if (index > 0)
            this.$offset(index);
        return this.later(function (results) {
            var Model = _this.Model;
            var result = results[0];
            return result instanceof Model ? result : null;
        });
    };
    Spell.prototype.later = function (resolve) {
        this.laters.push(resolve);
        return this;
    };
    Spell.prototype.ignite = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, Model, laters, result, laters_1, laters_1_1, later, e_8_1;
            var e_8, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this, Model = _a.Model, laters = _a.laters;
                        return [4 /*yield*/, Model.driver.cast(this)];
                    case 1:
                        result = _c.sent();
                        result = __assign(__assign({}, result), { spell: this });
                        _c.label = 2;
                    case 2:
                        _c.trys.push([2, 7, 8, 9]);
                        laters_1 = __values(laters), laters_1_1 = laters_1.next();
                        _c.label = 3;
                    case 3:
                        if (!!laters_1_1.done) return [3 /*break*/, 6];
                        later = laters_1_1.value;
                        return [4 /*yield*/, later(result)];
                    case 4:
                        result = _c.sent();
                        _c.label = 5;
                    case 5:
                        laters_1_1 = laters_1.next();
                        return [3 /*break*/, 3];
                    case 6: return [3 /*break*/, 9];
                    case 7:
                        e_8_1 = _c.sent();
                        e_8 = { error: e_8_1 };
                        return [3 /*break*/, 9];
                    case 8:
                        try {
                            if (laters_1_1 && !laters_1_1.done && (_b = laters_1.return)) _b.call(laters_1);
                        }
                        finally { if (e_8) throw e_8.error; }
                        return [7 /*endfinally*/];
                    case 9: return [2 /*return*/, result];
                }
            });
        });
    };
    /**
     * Fake spell as a thenable object so it can be consumed like a regular Promise.
     * @example
     * const post = await Post.first
     * Post.last.then(post => handle(post));
     * @param {Function} resolve
     * @param {Function} reject
     */
    Spell.prototype.then = function (resolve, reject) {
        if (resolve === void 0) { resolve = null; }
        return this.ignite().then(resolve, reject);
    };
    /**
     * @param {Function} reject
     */
    Spell.prototype.catch = function (reject) {
        return this.then(null, reject);
    };
    /**
     * @param {Function} onFinally
     */
    Spell.prototype.finally = function (onFinally) {
        return this.then().finally(onFinally);
    };
    /**
     * - https://nodejs.org/en/knowledge/errors/what-are-the-error-conventions/
     * @param {Function} callback
     */
    Spell.prototype.nodeify = function (callback) {
        return this.then(function resolve(result) {
            callback(null, result);
        }, function reject(err) {
            callback(err);
        });
    };
    /**
     * Generate an INSERT query.
     * @private
     * @param {Object} obj - key-values pairs
     */
    Spell.prototype.$insert = function (obj) {
        this.command = 'insert';
        this.sets = parseSet(this, obj);
        return this;
    };
    /**
     * Generate a upsert-like query which takes advantage of ON DUPLICATE KEY UPDATE.
     * @private
     * @param {Object} obj - key-value pairs to SET
     */
    Spell.prototype.$upsert = function (obj) {
        this.command = 'upsert';
        this.sets = parseSet(this, obj);
        return this;
    };
    Spell.prototype.$bulkInsert = function (records) {
        this.command = 'bulkInsert';
        this.sets = parseSet(this, records);
        return this;
    };
    /**
     * Whitelist columnAttributes to select. Can be called repeatedly to select more columnAttributes.
     * @param {...string} names
     * @example
     * .select('title');
     * .select('title', 'createdAt');
     * .select('IFNULL(title, "Untitled")');
     */
    Spell.prototype.$select = function () {
        var _a;
        var names = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            names[_i] = arguments[_i];
        }
        (_a = this.columns).push.apply(_a, __spreadArray([], __read(parseSelect.apply(void 0, __spreadArray([this], __read(names), false))), false));
        return this;
    };
    /**
     * Make a UPDATE query with values updated by generating SET key=value from obj.
     * @private
     * @param {Object} obj - key-value pairs to SET
     */
    Spell.prototype.$update = function (obj) {
        this.command = 'update';
        this.sets = parseSet(this, obj);
        return this;
    };
    Spell.prototype.$increment = function (name, by, opts) {
        var _a;
        if (by === void 0) { by = 1; }
        if (opts === void 0) { opts = {}; }
        var Model = this.Model;
        var silent = opts.silent;
        var timestamps = Model.timestamps;
        this.command = 'update';
        if (!Number.isFinite(by))
            throw new Error("unexpected increment value ".concat(by));
        if (!Model.columnAttributes.hasOwnProperty(name)) {
            throw new Error("undefined attribute \"".concat(name, "\""));
        }
        this.sets = __assign(__assign({}, this.sets), (_a = {}, _a[name] = {
            type: 'op',
            name: by > 0 ? '+' : '-',
            args: [
                { type: 'id', value: name, },
                { type: 'literal', value: Math.abs(by) },
            ],
            __expr: true,
        }, _a));
        if (timestamps.updatedAt && !this.sets[timestamps.updatedAt] && !silent) {
            this.sets[timestamps.updatedAt] = new Date();
        }
        return this;
    };
    Spell.prototype.$decrement = function (name, by, opts) {
        if (by === void 0) { by = 1; }
        if (opts === void 0) { opts = {}; }
        return this.$increment(name, -by, opts);
    };
    /**
     * Set query command to DELETE.
     * @returns {Spell}
     */
    Spell.prototype.$delete = function () {
        this.command = 'delete';
        return this;
    };
    /**
     * Set the table of the spell. If an instance of {@link Spell} is passed, it will be used as a derived table.
     * @param {string|Spell} table
     * @returns {Spell}
     */
    Spell.prototype.$from = function (table) {
        this.table = table instanceof Spell
            ? { type: 'subquery', value: table }
            : parseExpr(table);
        return this;
    };
    /**
     * Set WHERE conditions. Both string conditions and object conditions are supported.
     * @example
     * .where({ foo: null });
     * .where('foo = ? and bar >= ?', null, 42);
     * @param {string|Object} conditions
     * @param {...*}          values     - only necessary when using templated string conditions
     * @returns {Spell}
     */
    Spell.prototype.$where = function (conditions) {
        var _a;
        var values = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            values[_i - 1] = arguments[_i];
        }
        var Model = this.Model;
        (_a = this.whereConditions).push.apply(_a, __spreadArray([], __read(parseConditions.apply(void 0, __spreadArray([Model, conditions], __read(values), false))), false));
        return this;
    };
    Spell.prototype.$orWhere = function (conditions) {
        var values = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            values[_i - 1] = arguments[_i];
        }
        var whereConditions = this.whereConditions;
        if (whereConditions.length == 0)
            return this.$where.apply(this, __spreadArray([conditions], __read(values), false));
        var combined = whereConditions.slice(1).reduce(function (result, condition) {
            return { type: 'op', name: 'and', args: [result, condition] };
        }, whereConditions[0]);
        var Model = this.Model;
        this.whereConditions = [
            { type: 'op', name: 'or', args: __spreadArray([combined], __read(parseConditions.apply(void 0, __spreadArray([Model, conditions], __read(values), false))), false) }
        ];
        return this;
    };
    /**
     * Set GROUP BY columnAttributes. `select_expr` with `AS` is supported, hence following expressions have the same effect:
     *
     *     .select('YEAR(createdAt)) AS year').group('year');
     *
     * @example
     * .group('city');
     * .group('YEAR(createdAt)');
     * @param {...string} names
     * @returns {Spell}
     */
    Spell.prototype.$group = function () {
        var e_9, _a;
        var names = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            names[_i] = arguments[_i];
        }
        var _b = this, columns = _b.columns, groups = _b.groups, Model = _b.Model;
        var _loop_4 = function (name_4) {
            if (Model.attributes[name_4] && Model.attributes[name_4].virtual) {
                throw new Error("unable to use virtual attribute ".concat(name_4, " as group column in model ").concat(Model.name));
            }
            var token = parseExpr(name_4);
            if (token.type === 'alias') {
                groups.push({ type: 'id', value: token.value });
            }
            else {
                groups.push(token);
            }
            if (!columns.some(function (entry) { return entry.value === token.value; })) {
                columns.push(token);
            }
        };
        try {
            for (var names_2 = __values(names), names_2_1 = names_2.next(); !names_2_1.done; names_2_1 = names_2.next()) {
                var name_4 = names_2_1.value;
                _loop_4(name_4);
            }
        }
        catch (e_9_1) { e_9 = { error: e_9_1 }; }
        finally {
            try {
                if (names_2_1 && !names_2_1.done && (_a = names_2.return)) _a.call(names_2);
            }
            finally { if (e_9) throw e_9.error; }
        }
        return this;
    };
    /**
     * Set the ORDER of the query
     * @example
     * .order('title');
     * .order('title', 'desc');
     * .order({ title: 'desc' });
     * .order('id asc, gmt_created desc')
     * @param {string|Object} name
     * @param {string} direction
     * @returns {Spell}
     */
    Spell.prototype.$order = function (name, direction) {
        var _this = this;
        if (isPlainObject(name)) {
            if (name instanceof Raw) {
                this.orders.push([
                    name,
                ]);
            }
            else {
                for (var prop in name) {
                    this.$order(prop, name[prop]);
                }
            }
        }
        else if (/^(.+?)\s+(asc|desc)$/i.test(name)) {
            var conditions = name.split(',');
            conditions.map(function (cond) {
                var _a;
                _a = __read(cond.match(/^(.+?)\s+(asc|desc)$/i), 3), name = _a[1], direction = _a[2];
                _this.$order(name, direction);
            });
        }
        else {
            var order = [
                parseExpr(name),
                direction && direction.toLowerCase() == 'desc' ? 'desc' : 'asc'
            ];
            checkCond(this.Model, order);
            this.orders.push(order);
        }
        return this;
    };
    /**
     * Set the OFFSET of the query.
     * @param {number} skip
     * @returns {Spell}
     */
    Spell.prototype.$offset = function (skip) {
        skip = +skip;
        if (Number.isNaN(skip))
            throw new Error("invalid offset ".concat(skip));
        this.skip = skip;
        return this;
    };
    /**
     * Set the LIMIT of the query.
     * @param {number} rowCount
     * @returns {Spell}
     */
    Spell.prototype.$limit = function (rowCount) {
        rowCount = +rowCount;
        if (Number.isNaN(rowCount))
            throw new Error("invalid limit ".concat(rowCount));
        this.rowCount = rowCount;
        return this;
    };
    /**
     * Set the HAVING conditions, which usually appears in GROUP queries only.
     * @example
     * .having('average between ? and ?', 10, 20);
     * .having('maximum > 42');
     * .having({ count: 5 });
     *
     * @param {string|Object} conditions
     * @param {...*}          values
     * @returns {Spell}
     */
    Spell.prototype.$having = function (conditions) {
        var e_10, _a, e_11, _b;
        var values = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            values[_i - 1] = arguments[_i];
        }
        var Model = this.Model;
        try {
            for (var _c = __values(parseConditions.apply(void 0, __spreadArray([Model, conditions], __read(values), false))), _d = _c.next(); !_d.done; _d = _c.next()) {
                var condition = _d.value;
                // Postgres can't have alias in HAVING clause
                // https://stackoverflow.com/questions/32730296/referring-to-a-select-aggregate-column-alias-in-the-having-clause-in-postgres
                if (Model.driver.type === 'postgres' && !(condition instanceof Raw)) {
                    var value = condition.args[0].value;
                    try {
                        for (var _e = (e_11 = void 0, __values(this.columns)), _f = _e.next(); !_f.done; _f = _e.next()) {
                            var column = _f.value;
                            if (column.value === value && column.type === 'alias') {
                                condition.args[0] = deepClone(column.args[0]);
                                break;
                            }
                        }
                    }
                    catch (e_11_1) { e_11 = { error: e_11_1 }; }
                    finally {
                        try {
                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                        }
                        finally { if (e_11) throw e_11.error; }
                    }
                }
                this.havingConditions.push(condition);
            }
        }
        catch (e_10_1) { e_10 = { error: e_10_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_10) throw e_10.error; }
        }
        return this;
    };
    Spell.prototype.$orHaving = function (conditions) {
        var values = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            values[_i - 1] = arguments[_i];
        }
        this.$having.apply(this, __spreadArray([conditions], __read(values), false));
        var havingConditions = this.havingConditions;
        var len = havingConditions.length;
        var combined = havingConditions.slice(1, len - 1).reduce(function (result, condition) {
            return { type: 'op', name: 'and', args: [result, condition] };
        }, havingConditions[0]);
        this.havingConditions = [
            { type: 'op', name: 'or', args: [combined, havingConditions[len - 1]] }
        ];
        return this;
    };
    /**
     * LEFT JOIN predefined associations in model.
     * @example
     * .with('attachment');
     * .with('attachment', 'comments');
     * .with({ comments: { select: 'content' } });
     *
     * @param {...string} qualifiers
     * @returns {Spell}
     */
    Spell.prototype.$with = function () {
        var e_12, _a;
        var qualifiers = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            qualifiers[_i] = arguments[_i];
        }
        if (this.rowCount > 0 || this.skip > 0) {
            var spell = this.dup;
            spell.columns = [];
            __classPrivateFieldGet(this, _Spell_instances, "m", _Spell_emptySpell).call(this);
            this.table = { type: 'subquery', value: spell };
        }
        try {
            for (var qualifiers_1 = __values(qualifiers), qualifiers_1_1 = qualifiers_1.next(); !qualifiers_1_1.done; qualifiers_1_1 = qualifiers_1.next()) {
                var qualifier = qualifiers_1_1.value;
                if (isPlainObject(qualifier)) {
                    for (var key in qualifier) {
                        joinAssociation(this, this.Model, this.Model.tableAlias, key, qualifier[key]);
                    }
                }
                else {
                    joinAssociation(this, this.Model, this.Model.tableAlias, qualifier);
                }
            }
        }
        catch (e_12_1) { e_12 = { error: e_12_1 }; }
        finally {
            try {
                if (qualifiers_1_1 && !qualifiers_1_1.done && (_a = qualifiers_1.return)) _a.call(qualifiers_1);
            }
            finally { if (e_12) throw e_12.error; }
        }
        return this;
    };
    /**
     * LEFT JOIN arbitrary models with specified ON conditions.
     * @example
     * .join(User, 'users.id = posts.authorId');
     * .join(TagMap, 'tagMaps.targetId = posts.id and tagMaps.targetType = 0');
     *
     * @param {Model}         Model
     * @param {string|Object} onConditions
     * @param {...*}          values
     * @returns {Spell}
     */
    Spell.prototype.$join = function (Model, onConditions) {
        var values = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            values[_i - 2] = arguments[_i];
        }
        if (typeof Model === 'string') {
            return this.$with.apply(this, __spreadArray([], __read(arguments), false));
        }
        var qualifier = Model.tableAlias;
        var joins = this.joins;
        if (qualifier in joins) {
            throw new Error("invalid join target. ".concat(qualifier, " already defined."));
        }
        joins[qualifier] = { Model: Model, on: parseConditions.apply(void 0, __spreadArray([Model, onConditions], __read(values), false))[0] };
        return this;
    };
    /**
     * add optimizer hints to query
     * @example
     * .optimizerHints('SET_VAR(foreign_key_checks=OFF)')
     * .optimizerHints('SET_VAR(foreign_key_checks=OFF)', 'MAX_EXECUTION_TIME(1000)')
     * @param {...string} hints
     * @returns {Spell}
     * @memberof Spell
     */
    Spell.prototype.$optimizerHints = function () {
        var _a;
        var hints = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            hints[_i] = arguments[_i];
        }
        (_a = this.hints).push.apply(_a, __spreadArray([], __read(hints.map(function (hint) { return Hint.build(hint); })), false));
        return this;
    };
    /**
     * @example
     * .useIndex('idx_id')
     * .useIndex('idx_id', 'idx_title_id')
     * .useIndex('idx_id', { orderBy: ['idx_title', 'idx_org_id'] }, { groupBy: 'idx_type' })
     * @param {string | object} hints
     * @returns {Spell}
     * @memberof Spell
     */
    Spell.prototype.$useIndex = function () {
        var _a;
        var hints = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            hints[_i] = arguments[_i];
        }
        (_a = this.hints).push.apply(_a, __spreadArray([], __read(hints.map(function (hint) {
            if (hint instanceof IndexHint && hint.type !== INDEX_HINT_TYPE.use) {
                console.warn('Do not recommend set non-use index hint in useIndex');
            }
            return IndexHint.build(hint, INDEX_HINT_TYPE.use);
        })), false));
        return this;
    };
    /**
     * @example
     * .forceIndex('idx_id')
     * .forceIndex('idx_id', 'idx_title_id')
     * .forceIndex('idx_id', { orderBy: ['idx_title', 'idx_org_id'] }, { groupBy: 'idx_type' })
     * @param {string | object} hints
     * @returns {Spell}
     * @memberof Spell
     */
    Spell.prototype.$forceIndex = function () {
        var _a;
        var hints = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            hints[_i] = arguments[_i];
        }
        (_a = this.hints).push.apply(_a, __spreadArray([], __read(hints.map(function (hint) {
            if (hint instanceof Hint || (hint instanceof IndexHint && hint.type !== INDEX_HINT_TYPE.force)) {
                console.warn('Do not recommend set non-force index hint in forceIndex');
            }
            return IndexHint.build(hint, INDEX_HINT_TYPE.force);
        })), false));
        return this;
    };
    /**
     * @example
     * .ignoreIndex('idx_id')
     * .ignoreIndex('idx_id', 'idx_title_id')
     * .ignoreIndex('idx_id', { orderBy: ['idx_title', 'idx_org_id'] }, { groupBy: 'idx_type' })
     * @param {string | object} hints
     * @returns {Spell}
     * @memberof Spell
     */
    Spell.prototype.$ignoreIndex = function () {
        var _a;
        var hints = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            hints[_i] = arguments[_i];
        }
        (_a = this.hints).push.apply(_a, __spreadArray([], __read(hints.map(function (hint) {
            if (hint instanceof IndexHint && hint.type !== INDEX_HINT_TYPE.ignore) {
                console.warn('Do not recommend set non-ignore index hint in ignoreIndex');
            }
            return IndexHint.build(hint, INDEX_HINT_TYPE.ignore);
        })), false));
        return this;
    };
    /**
     * Get the query results by batch. Returns an async iterator which can then be consumed with an async loop or the cutting edge `for await`. The iterator is an Object that contains a `next()` method:
     *
     *     const iterator = {
     *       i: 0,
     *       next: () => Promise.resolve(this.i++);
     *     }
     *
     * See examples to consume async iterators properly. Currently async iterator is [proposed](https://github.com/tc39/proposal-async-iteration) and [implemented by V8](https://jakearchibald.com/2017/async-iterators-and-generators/) but hasn't made into Node.js LTS yet.
     * @example
     * async function consume() {
     *   const batch = Post.all.batch();
     *   while (true) {
     *     const { done, value: post } = await batch.next();
     *     if (value) handle(post);
     *     if (done) break
     *   }
     * }
     * // or
     * for await (const post of Post.all.batch()) {
     *    handle(post);
     * }
     *
     * @param {number} size
     * @returns {Object}
     */
    Spell.prototype.batch = function (size) {
        if (size === void 0) { size = 1000; }
        return __asyncGenerator(this, arguments, function batch_1() {
            var limit, spell, results, results_1, results_1_1, result, e_13_1;
            var e_13, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        limit = parseInt(size, 10);
                        if (!(limit > 0))
                            throw new Error("invalid batch limit ".concat(size));
                        spell = this.limit(limit);
                        return [4 /*yield*/, __await(spell)];
                    case 1:
                        results = _b.sent();
                        _b.label = 2;
                    case 2:
                        if (!(results.length > 0)) return [3 /*break*/, 13];
                        _b.label = 3;
                    case 3:
                        _b.trys.push([3, 9, 10, 11]);
                        results_1 = (e_13 = void 0, __values(results)), results_1_1 = results_1.next();
                        _b.label = 4;
                    case 4:
                        if (!!results_1_1.done) return [3 /*break*/, 8];
                        result = results_1_1.value;
                        return [4 /*yield*/, __await(result)];
                    case 5: return [4 /*yield*/, _b.sent()];
                    case 6:
                        _b.sent();
                        _b.label = 7;
                    case 7:
                        results_1_1 = results_1.next();
                        return [3 /*break*/, 4];
                    case 8: return [3 /*break*/, 11];
                    case 9:
                        e_13_1 = _b.sent();
                        e_13 = { error: e_13_1 };
                        return [3 /*break*/, 11];
                    case 10:
                        try {
                            if (results_1_1 && !results_1_1.done && (_a = results_1.return)) _a.call(results_1);
                        }
                        finally { if (e_13) throw e_13.error; }
                        return [7 /*endfinally*/];
                    case 11: return [4 /*yield*/, __await(spell.$offset(spell.skip + limit))];
                    case 12:
                        results = _b.sent();
                        return [3 /*break*/, 2];
                    case 13: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Format current spell to SQL string.
     * @returns {string}
     */
    Spell.prototype.toSqlString = function () {
        var Model = this.Model;
        var _a = Model.driver.format(this), sql = _a.sql, values = _a.values;
        return SqlString.format(sql, values);
    };
    /**
     * Alias of {@link Spell#toSqlString}
     * @returns {string}
     */
    Spell.prototype.toString = function () {
        return this.toSqlString();
    };
    return Spell;
}());
_Spell_instances = new WeakSet(), _Spell_emptySpell = function _Spell_emptySpell() {
    Object.assign(this, {
        whereConditions: [],
        groups: [],
        orders: deepClone(this.orders),
        havingConditions: [],
        joins: {},
        subqueryIndex: 0,
        rowCount: 0,
        skip: 0,
    });
};
var _loop_1 = function (aggregator) {
    var func = AGGREGATOR_MAP[aggregator];
    Object.defineProperty(Spell.prototype, "$".concat(aggregator), {
        configurable: true,
        writable: true,
        value: function Spell_aggregator(name) {
            if (name === void 0) { name = '*'; }
            if (name instanceof Raw) {
                this.$select(Raw.build("".concat(func.toUpperCase(), "(").concat(name, ") AS ").concat(aggregator)));
                return this;
            }
            if (name !== '*' && parseExpr(name).type !== 'id') {
                throw new Error("unexpected operand ".concat(name, " for ").concat(func.toUpperCase(), "()"));
            }
            this.$select("".concat(func, "(").concat(name, ") as ").concat(aggregator));
            return this;
        }
    });
};
for (var aggregator in AGGREGATOR_MAP) {
    _loop_1(aggregator);
}
var _loop_2 = function (method) {
    if (method.startsWith('$')) {
        var descriptor = Object.getOwnPropertyDescriptor(Spell.prototype, method);
        Object.defineProperty(Spell.prototype, method.slice(1), Object.assign({}, descriptor, {
            value: function Spell_dup() {
                var spell = this.dup;
                spell[method].apply(spell, __spreadArray([], __read(arguments), false));
                return spell;
            }
        }));
    }
};
try {
    for (var _e = __values(Object.getOwnPropertyNames(Spell.prototype)), _f = _e.next(); !_f.done; _f = _e.next()) {
        var method = _f.value;
        _loop_2(method);
    }
}
catch (e_1_1) { e_1 = { error: e_1_1 }; }
finally {
    try {
        if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
    }
    finally { if (e_1) throw e_1.error; }
}
module.exports = Spell;
//# sourceMappingURL=spell.js.map